import { useAccount } from "../../hooks/useAccount"
import Stats from "./Stats"
import StatsStudyGroupOverview from "./StatsStudyGroupOverview"

export const StatsContainer = () => {
  const { account } = useAccount()

  return account?.role === "study_group_overviewer" ? (
    <StatsStudyGroupOverview />
  ) : (
    <Stats />
  )
}
